
// import { nanoid } from 'nanoid'
import React from 'react'
// import { setObject } from '../../utils/useful'
// import FormViewer from '../FormViewer'
// import { apisObject } from '../../variables/FetchInputApis'
// import SelectInput from './SelectInput'
import HttpServices from '../../utils/Http.services'
import { checkTranslation, checkVariablesListForValue, translate } from '../../utils/useful'
// import ParamsInput from './ParamsInput'
// import TextInput from './TextInput'
// import FixedView from '../FixedView'
// import ParamsStageList from './ParamsStageList'
import TextInputWithParams from './TextInputWithParams'


class PageParamsInput extends React.Component {

    state = {
        params: [
            // { name: 'category', },
            // { name: 'provider', }
        ],

    }


    componentDidMount() {

        this.init()
        // this.setFullParams()


    }

    componentDidUpdate(prevProps) {
        if (prevProps.header?.information?.frame !== this.props.header?.information?.frame) {
            this.init()
        }

        // if (this.props.params != prevProps.params) {
        //     this.setFullParams()
        // }
    }



    // setFullParams = () => {


    //     let fullParams = {}

    //     if (Array.isArray(this.props.params)) {
    //         for (let i = 0; i < this.props.params.length; i++) {
    //             const param = this.props.params[i];
    //             fullParams[param.value] = { key: param.key ?? param.value, label: param.label, list: param.fields ?? param.list, info: param.info }
    //         }
    //     }else{
    //         fullParams = this.props.params
    //     }

    //     // console.log(fullParams)
    //     this.setState({ fullParams })
    // }




    init() {

        // console.log('init',this.props.header?.information)

        if (this.props.header?.information?.frame) {
            let body = { filter: {} }

            if (!Array.isArray(this.props.header?.information?.frame)) {
                body.filter._id = [this.props.header?.information?.frame]
            } else {
                body.filter._id = this.props.header?.information?.frame
            }
            this.setState({ showFixedView: false })


            HttpServices.request('getFrames', body, (fetchResult, fetchError) => {


                // console.log(fetchResult)
                this.setState({ isLoadingHeaders: false })
                if (fetchError) {
                    this.setState({ fetchError })
                    return
                }

                let params = []

                let frame = fetchResult.info[0]


                // TO DO: CONSIDER ADDING THE FRAMES NAMES TO INDICATED DIFFERENT KEYS
                if (frame) {

                    params = frame.config.params ?? []

                }

                let newData
                // console.log(this.props.data)
                if (this.props.data && typeof this.props.data == 'object') {
                    newData = {}
                    for (let i = 0; i < Object.values(this.props.data).length; i++) {
                        const element = Object.values(this.props.data)[i];

                        for (let j = 0; j < params.length; j++) {
                            const param = params[j]

                            if (param.id == element.id) {
                                newData[param.name] = { name: param.name, value: element.value, type: param.type, id: param.id, index: j }
                            }

                        }
                    }
                }



                this.setState({ params }, () => {
                    this.setState({ showFixedView: true })
                    this.props.changeValue(this.props.header?.key, newData, this.props.extra)

                })



            })
        } else {
            this.setState({ params: [] }, () => { })
        }

    }


    changeValue = (key, value, extra) => {

        this.props.changeValue(this.props.header?.key, value, this.props.extra)

    }

    changeParamValue = (key, value, extra) => {

        // console.log('changeParamValue', key, value, extra)
        let data = this.props.data ?? {}

        if (key) {
            data[key] = { name: key, value: value, type: extra.type, id: extra.id, index: extra.index }
        }

        // console.log(data)
        this.props.changeValue(this.props.header?.key, data, this.props.extra)
       


    }



    render() {



        return (
            <div className=''>

                {this.state.params?.length == 0 &&(
                    <p className='font-size-13 color-gray-2'>{translate("No param for the page")}</p>
                )}

                {this.state.params.map((param, index) => {

                    // let value = this.props.data?.[param.name]?.value
                    // if (value && /\{\{(.*?)\}\}/.test(value)) {
                    //     let baseValue = value.replace(/{/g, '').replace(/}/g, '')

                    //     value = checkVariablesListForValue(this.state.fullParams, baseValue)?.label
                    //     // console.log(value)
                    //     if (value) {
                    //         value = '{{' + value + '}}'
                    //     }
                    // }

                    return (
                        <div className={'flexc ' + (index < this.state.params.length - 1 ? 'mb-1' : '')} key={index}>

                            <div className='flex-1'>
                                <p className={'font-size-13 ' + (param.required ? 'required' : '')}>{checkTranslation(param.name)}</p>
                                <p className={'font-size-10 color-gray-2 text-capitalize'}>{translate(`${param.type} param`)}</p>
                            </div>

                            <div className='flex-2 bordered-input flexc' >
                                <TextInputWithParams data={this.props.data?.[param.name]?.value} header={{ key: param.name, information: {} }} extra={{ id: param.id, type: param.type, index }} changeValue={this.changeParamValue}  params={this.props.params} />
                                {/* <TextInput data={value} header={{ key: param.name, information: {} }} extra={{ id: param.id, type: param.type, index }} params={this.props.params} changeValue={this.changeParamValue} />

                                <div className="flexcc">

                                    <button ref={el => this[`target-${param.id}`] = el} className=" font-size-12 mld-2 white br-20 text-semibold flexcc" style={{ backgroundColor: '#ddd', padding: 5, }} onClick={() => this[`fixedView-${param.id}`]?.showView()}>
                                        <img className="  " src="/assets/icons/useful/brackets-curly.svg" alt="" height={12} />
                                    </button>


                                    {this.state.showFixedView && (
                                        <FixedView zIndex={10} ref={el => this[`fixedView-${param.id}`] = el} nodeRef={this[`target-${param.id}`]} xOffset={-12} bottomOffset={27} topOffset={5} width={180} maxWidth={180} >

                                            <div className='bg-white br-10 p-2 shadow-3  w-100' style={{}}>

                                                <ParamsStageList params={this.state.fullParams} header={{ key: param.name }} data={this.props.data?.[param.name]?.value} changeValue={this.changeParamValue} extra={{ id: param.id, type: param.type, index }} asVariable={true} />

                                            </div>
                                        </FixedView>
                                    )}
                                </div> */}
                                {/* <ParamsInput header={{ key: param.name, information: {} }} params={this.props.params} changeValue={this.changeParamValue} /> */}
                            </div>
                        </div>
                    )
                })}

            </div>
        );
    }
}

export default PageParamsInput;